import React from 'react'
import { GridItem, NavigationLinkBlock } from '@which/seatbelt'

import type {
  LatestNews as LatestNewsType,
  RelatedGuides as RelatedGuidesType,
  SubVerticalReviewsPageQuery,
} from '../../../../generated/frontend'
import { Breadcrumb } from '../../../../shared/components/Breadcrumb/Breadcrumb'
import { LatestNewsCards } from '../../../../shared/components/LatestNewsCards/LatestNewsCards'
import { LocalFooter } from '../../../../shared/components/LocalFooter/LocalFooter'
import { TaxonomyConversionBanner } from '../../../../shared/components/TaxonomyConversionBanner/TaxonomyConversionBanner'
import { ToolCTA } from '../../../../shared/components/ToolCTA/ToolCTA'
import { BannerSignUp } from '../../components/BannerSignUp'
import { RelatedGuides } from '../../components/RelatedGuides'
import { SuperCategoryJumpLinks } from '../../components/SuperCategoryJumpLinks'
import { SuperCategorySection } from '../../components/SuperCategorySection'
import styles from '../../SubVerticalPage.module.scss'
import { FullWidthSubVerticalHeader } from './components/FullWidthSubVerticalHeader/FullWidthSubVerticalHeader'

export const getSubVerticalReviewsComponents = (
  data: SubVerticalReviewsPageQuery['subVerticalPage']
) => {
  const {
    breadcrumb,
    taxonomyConversionBanner,
    header,
    reviewsCategories,
    subVerticalOptionalData,
    latestNews,
    categoryLinks,
  } = data

  return {
    Breadcrumb: () => <Breadcrumb {...breadcrumb} />,

    TaxonomyConversionBanner: () => (
      <GridItem span={{ small: 'full-bleed', medium: 'full-bleed', large: 'full-bleed' }}>
        <TaxonomyConversionBanner {...taxonomyConversionBanner} />
      </GridItem>
    ),

    SubVerticalHeader: () => <FullWidthSubVerticalHeader {...header} variant="reviews" />,

    SubVerticalJumpLinks: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SuperCategoryJumpLinks links={reviewsCategories?.jumpLinks?.links} />
      </GridItem>
    ),

    SuperCategorySections: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SuperCategorySection superCategorySections={reviewsCategories?.sections} />
      </GridItem>
    ),
    BannerSignUp: () =>
      subVerticalOptionalData?.components?.bannerSignUpComponentData ? (
        <BannerSignUp
          {...subVerticalOptionalData.components.bannerSignUpComponentData}
        ></BannerSignUp>
      ) : (
        <></>
      ),
    LatestNews: () => (
      <GridItem span={{ medium: 12, large: 12 }}>
        <LatestNewsCards
          name={latestNews?.name}
          articles={latestNews?.articles as LatestNewsType['articles']}
          viewAllData={{ text: 'View all news', href: '/news' }}
        />
      </GridItem>
    ),
    CategoryNavigation: () =>
      categoryLinks?.length ? (
        <GridItem
          className={styles.categoryNavigation}
          span={{ medium: 10, large: 10 }}
          columnStart={{ medium: 2, large: 2 }}
        >
          <NavigationLinkBlock links={categoryLinks} />
        </GridItem>
      ) : (
        <></>
      ),
    MoneyToolCTA: () =>
      subVerticalOptionalData?.components?.toolCTA ? (
        <GridItem
          span={{ medium: 10, large: 10 }}
          columnStart={{ medium: 2, large: 2 }}
          className={styles.moneyToolCTA}
        >
          <ToolCTA {...subVerticalOptionalData?.components?.toolCTA}></ToolCTA>
        </GridItem>
      ) : (
        <></>
      ),
    RelatedGuides: () =>
      subVerticalOptionalData?.components?.relatedGuides?.guides?.length ? (
        <GridItem
          className={styles.relatedGuides}
          span={{ medium: 10, large: 10 }}
          columnStart={{ medium: 2, large: 2 }}
        >
          <RelatedGuides
            data={subVerticalOptionalData.components.relatedGuides as RelatedGuidesType}
          ></RelatedGuides>
        </GridItem>
      ) : (
        <></>
      ),
    LocalFooter: subVerticalOptionalData?.components?.localFooter
      ? () => (
          <GridItem className={styles.localFooter} span={{ medium: 12, large: 12 }}>
            <LocalFooter data={subVerticalOptionalData.components.localFooter}></LocalFooter>
          </GridItem>
        )
      : () => <></>,
  }
}
